<template>
	<div class="con" v-loading="loading">
		<div class="list" v-for="(item,i) in list" :key="i" @click="detail(item.id)">
			<div class="list01">
				<img :src="item.imgurl" alt="">
			</div>
			<div class="list02">
				<div class="el-col el-col-3">
					<div class="til">{{bian(item.createTime).day}}</div>
					<div class="sub-til">{{bian(item.createTime).year}}-{{bian(item.createTime).month}}</div>
				</div>
				<div class="el-col el-col-20">
					<div class="news-info" style="cursor: pointer;">
						<div class="news-til">
							 {{item.title}}
						</div>
						<div class="news-tils">
							{{item.intor}}
						</div>
					</div>
				</div>
			</div>
		</div>
		
		<!-- 分页 -->
		<div class="pagination-container">
		  <el-pagination
		    :current-page="listQuery.page"
		    :page-sizes="[10,20,30, 40]"
		    :page-size="listQuery.limit"
		    :total="total"
		    background layout="total, sizes, prev, pager, next, jumper"
		    @size-change="handleSizeChange"
		    @current-change="handleCurrentChange"
		  />
		</div>
	</div>
</template>

<script>
   import { news_list } from "@/api/news"
   import { TimeYYdAY } from "@/utils/rules"
   export default {
	   data(){
		   return{
			   listQuery:{
				   page:1,
				   limit:10,
				   type:1
			   },
			   list:[],
			   total:0,
			   loading:false,
			   
			   url: this.$url
		   }
	   },
	   mounted(){
		   this.listQuery.type = this.$route.query.type?this.$route.query.type:1;
		   this.news_list();
	   },
	   methods:{
		   bian(time){
		   	let date = new Date(time);
		   	return TimeYYdAY(date);
		   },
		   news_list(){
			   this.loading = true
			   news_list(this.listQuery).then(res=>{
				   this.loading = false
				   console.log("文章列表",res.data);
				   this.total = res.data.total
				   this.list = res.data.list
			   }).catch(()=>{
				   this.loading = false
			   })
		   },
		   detail(id){
			   this.$router.push({
				   path:"/newsdetail",
				   query:{
					   id:id
				   }
			   })
		   },
		  //下一页上一页操作
		  handleSizeChange(val) {//条数
		    this.listQuery.limit = val
			this.news_list();
		  },
		  handleCurrentChange(val) {//列数
		    this.listQuery.page = val
			this.news_list();
		  }, 
	   },
   }
</script>

<style lang="scss">
	.con{
		.news-til:after{
			content: "";
			width: 78px;
			height: 2px;
			background: #e94960;
			position: absolute;
			bottom: -18px;
			left: 0;
			display: block;
		}
		.news-til{
			font-weight: 700;
			color: #222;
			font-size: 20px;
			position: relative;
			margin-bottom: 30px;
		}
		.news-tils{
			color: #333;
			font-size: 16px;
			line-height: 35px;
			overflow: hidden;
			display: -webkit-box;
			text-overflow: ellipsis;
			-webkit-box-orient: vertical;
			-webkit-line-clamp: 2;
		}
		width: 1200px;
		margin: 0 auto;
		padding-top: 30px;
		padding-bottom: 30px;
		.list{
			width: 100%;
			display: flex;
			align-items: center;
			margin-bottom: 50px;
			.list02{
				width: 70%;
				height: 150px;
				margin:0 auto;
				
				.sub-til{
					color: #999;
					font-size: 12px
				}
				.til{
					color: #999;
					font-size: 42px;
					font-weight: 600;
				}
			}
			.list01{
				width: 25%;
				height: 150px;
				background: #fff;
				border-radius: 5px;
				img{
					width: 100%;
					height: 100%;
					border-radius: 5px;
				}
			}
		}
	}
</style>


// WEBPACK FOOTER //
// src/views/news/index.vue